module.exports = __webpack_public_path__ + "media/images/logo-carnis-8272c7057aeb44496653cd9c8d4f33d7.png";